if (!customElements.get('tabbed-stats')) {
  customElements.define(
    'tabbed-stats',
    class TabbedStats extends HTMLElement {
      layout = '';
      selectedTab;
      selectedTabContent;

      constructor() {
        super();
        this.id = this.dataset.id;
        this.content = Array.from(this.getElementsByClassName('hidden')).map(
          html => JSON.parse(html.innerHTML),
        );
        this.selectedTab = this.content[0].tab;
        this.tabs = Array.from(this.getElementsByClassName('inner-tab'));
        this.links = Array.from(this.getElementsByClassName('report-link'));
        this.setSelectedTabContent();
        this.setLayout();

        this.addEventListener(this.id, this.switchTab);
      }

      setSelectedTabContent = () => {
        this.selectedTabContent = this.content.find(
          content => content.tab === this.selectedTab,
        );
      };

      switchTab = e => {
        this.selectedTab = e.detail.tab;
        this.setSelectedTabContent();
        this.tabs.forEach(tab => tab.classList.remove('selected'));
        this.links.forEach(link => link.classList.remove('selected'));
        this.tabs
          .find(tab => tab.id === `${this.id}${this.selectedTab}`)
          .classList.add('selected');
        try {
          this.links
            .find(link => link.classList.contains(this.selectedTab))
            .classList.add('selected');
        } catch (e) {}
        this.setLayout();
      };

      setLayout = () => {
        if (this.selectedTabContent.stat4) {
          this.layout = 'full-stats';
        } else if (this.selectedTabContent.image) {
          if (this.selectedTabContent.stat2 || this.selectedTabContent.stat3) {
            this.layout = 'img-stats';
          } else {
            this.layout = 'img-only';
          }
        }
        this.tabs
          .find(tab => tab.id === `${this.id}${this.selectedTab}`)
          .classList.add(this.layout);
      };
    },
  );
}
